import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faPhone } from "@fortawesome/free-solid-svg-icons";
import "../../../Styles/Redirecting Styles/NavbarStyles/Dedicate.css";
import Shape2 from "../../../assets/brand/choose-shape-2.png";
import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss";
import { Helmet } from "react-helmet";
import CanadaHeader1 from "../../Components/seperate Components/CanadaHeader1";
import CanadaFooter from "../../Components/Footer";

import section4 from "../../../assets/canada/Hire-a-resource/Hire A Dedicated Resources 1.jpg";

const CanadaDedicatedResource = () => {
  const [isOpen, setOpen] = useState(false);

  return (
    <div>
      <Helmet>
        <title>
        Hire A Resources in USA | Best Resource Hiring Services
        </title>
        <meta
          name="description"
          content="Explore top-notch resource hiring in USA. Hire dedicated resources for your projects. Get the best talents on board. Elevate your team's capabilities today!"
        />
        <meta
          name="keywords"
          content="hire dedicated resources USA, hire a resource USA, hire a best resource in USA, hire a resource"
        />
      </Helmet>
      <CanadaHeader1 />

      {/* Banner section */}
      <div
        className="bd-page-title-area bd-page-title-bg6 pt-220 pb-155"
        style={{ height: "380px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="bd-page-title text-center z-index"
                style={{ bottom: "45px" }}
              >
                <h2
                  className="breadcrumb-title"
                  style={{ fontSize: "50px", color: "#4a026c" }}
                >
               Build Your Dream Tech Team—Without the Hiring Hassle
                </h2>
                <div className="breadcrumb-menu">
                  <nav className="breadcrumb-trail breadcrumbs">
                    <nav className="breadcrumb-trail breadcrumbs">
                      <p style={{ color: "black" }}>
                      Top-Tier Talent. On Demand. Zero Overhead.
                      </p>
                    </nav>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* First Section */}
      <section className="bd-about-area">
        <div className="bd-custom-container">
          <div className="bd-about-four-bg  pt-80 pb-0 fix">
            <div className="bd-about-shape-box">
              <img
                className="bd-about-shape bd-about-shape-1"
                src="assets/img/shape/about-shape-3.png"
                alt="shape img not found"
              />
              <img
                className="bd-about-shape bd-about-shape-2"
                src="assets/img/shape/about-shape-4.png"
                alt="shape img not found"
              />
              <div className="container" style={{ maxWidth: "1270px" }}>
                <div className="row justify-content-center">
                  <div className="col-xl-6 col-lg-8  first_dedicate">
                    <div className="bd-choose-img text-end mb-30 z-index top-resp">
                      <div className="row align-items-center custom-mar-15">
                        <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                          <div className="bd-choose-img-inner mb-15 bd-choose-img-inner-1">
                            <img
                              src={'https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1747308498/USA%20website/HIRE%20A%20RESOURCE/Hire_a_Dedicated_Resource_jgxeit.png'}
                              className="resp-img bordertop-img1"
                              alt="img not found"
                            />
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-6 custom-pad-15">
                          <div className="bd-choose-img-inner mb-15">
                            <img
                              src={'https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1747308502/USA%20website/HIRE%20A%20RESOURCE/Hire_a_Dedicated_Resource_2_jszmma.png'}
                              className="resp-img bordertop-img2"
                              alt="img not found"
                            />
                          </div>
                          <div className="bd-choose-img-inner mb-15">
                            <img
                              src={'https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1747308499/USA%20website/HIRE%20A%20RESOURCE/Hire_a_Dedicated_Resource_1_b8vtd0.png'}
                              className="resp-img bordertop-img3"
                              alt="img not found"
                            />
                          </div>
                        </div>
                      </div>
                      <img
                        className="bd-choose-shape bd-choose-shape-2"
                        src={Shape2}
                        alt="shape img not found"
                      />
                      {/* <div className="bd-choose-video-popup">
                                                <a href="https://www.youtube.com/watch?v=jdkWIdJobSA" className="play_btn popup-video"><i className="fas fa-play"></i></a>
                                                </div> */}
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-8 second_dedicated">
                    <div className="bd-about-text bd-about-text-four z-index">
                      <div className="bd-section-title-wrapper">
                        <h2 className="bd-section-title md-pr-50 dedicate-first-tittle">
                        Why Hire a Dedicated Resource?
                        </h2>
                        <p>
                        Forget one-size-fits-all freelancers. Our dedicated resources are fully embedded into your workflow, aligned with your mission, and committed to long-term results. Whether you’re scaling a startup or modernizing an enterprise, we give you people who perform like they’re part of your in-house team—because they are.
                        </p>

                        <p>
                        Our dedicated team stands beside you—not just to support, but to truly understand your journey. We become part of your mission, handling the complexity so you can lead with clarity, passion, and purpose. When you have people who care about your success as much as you do, growth becomes natural—and your dream becomes unstoppable.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <ModalVideo autoplay isOpen={isOpen} channel='youtube' videoId='B-4CmrDidvE' onClose={() => setOpen(false)}>
                </ModalVideo>
                <button className="btn btn touch_pop_vid first_pop_video_dedicated" onClick={() => setOpen(true)}>
                    <FontAwesomeIcon icon={faPlay} className="play_bt_vid play_transition" />
                </button> */}
      </section>

      {/* Second Section */}
      <section className="bd-choose-area fix" style={{ marginTop: "+100px" }}>
        <div className="container" style={{ maxWidth: "1300px" }}>
          <div className="bd-choose-shape">
            <div className="row dedicated_first_responsive">
              <div className="col-xl-6 col-lg-6 order-2 order-lg-1 deicated-first_sec">
                {/* <div className="ablog ablog-4 mb-60"> */}
                <div className="bd-choose-text z-index">
                  <h2 className="bd-section-title ml-15 second_sec-tittle">
                  You Focus on Your Dream—We’ll Power the Engine Behind It{" "}
                  </h2>
                  <div className="bd-section-title-wrapper">
                    <p className="ml-25 dedicat-para1">
                    Every business starts with a vision—something personal, something you believe in. But chasing that dream shouldn’t mean drowning in tasks or losing time to the things that pull you away from what matters most. That’s where we come in.
                    </p>
                    <p className="ml-25 dedicat-para1">
                    Our dedicated team stands beside you—not just to support, but to truly understand your journey. We become part of your mission, handling the complexity so you can lead with clarity, passion, and purpose. When you have people who care about your success as much as you do, growth becomes natural—and your dream becomes unstoppable.
                    </p>
                    {/* <p className="ml-25 dedicat-para1">For the successful operation of a thriving enterprise, dedicated resources are indispensable. Engaging a cadre of professionals specializing in your specific industry enables your business to maintain its competitive advantage and secure financial prosperity. Navigating the vast sea of information can be overwhelming when deciding where to commence. That's exactly why we've established a dedicated resource team, ready to assist you in maximizing your business's potential.</p> */}
                  </div>
                  <div></div>
                </div>
                {/* </div> */}
              </div>
              <div className="col-xl-6 col-lg-6 order-1 order-lg-2 deicated-second_sec">
                <div className="bd-choose-img  z-index items-center" >
                  <div className="bd-choose-info-wrapper ">
                    <div className="container text-center">
                      <div className="row mb-50">
                        <div className="col first-point-col mr-50 justify-content-center">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440276/website/icons/workforce-64_heuj9y.png" />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Diverse and Skilled Workforce
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="col">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440276/website/icons/sand-timer-64_kx6y3a.png" />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Reduced Turnaround Time
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="container text-center">
                      <div className="row ">
                        <div className="col third-point-col mr-50">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440276/website/icons/report-64_kf5qew.png" />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Guaranteed Results
                              </h2>
                            </div>
                          </div>
                        </div>
                        <div className="col">
                          <div className="animate-hover">
                            <div className="bd-choose-info-icon mb-15">
                              <i>
                                <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440276/website/icons/infrastructure-64_ixjfps.png" />
                              </i>
                            </div>
                            <div className="bd-choose-info-text">
                              <h2
                                className="bd-choose-info-title mb-15"
                                style={{ color: "#5e5858" }}
                              >
                                Fasted Project Delivery
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Third Section */}
      <section className="bd-brand-area-two pb-75 pt-80">
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row second-dedicated-resp align-items-center">
            <div className="col-xl-4 col-lg-6 col-md-6 third-sec1-responsive">
              <div className="col-12">
                <div className="bd-section-title-wrapper mb-20">
                  <h2 className="bd-section-title mb-0 pl-0 fourth_sec_tittle-dedicat">
                  The Right People
                    <span style={{ color: "#ffbf1e" }}>
                      {" "}
                      The Right Place{" "}
                    </span>
                    The Right Result.
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-xl-8 col-lg-6 col-md-6 third-sec2-responsive">
              <div className="bd-brand-active-two swiper-container">
                <div className="swiper-wrapper">
                  <p style={{ fontSize: "18px", lineHeight: "1.75" }}>
                  Hiring a dedicated resource in the USA isn’t just about filling a role—it’s about unlocking possibility. With the right developer by your side, your vision turns into a product, your challenges turn into progress, and your business finds momentum you can feel.
                  </p>
                  <p style={{ fontSize: "18px", lineHeight: "1.75" }}>
                  We don’t offer templates—we offer tailored talent. Our handpicked experts dive deep into your needs, align with your goals, and help you build smarter, move faster, and grow stronger. In the heart of the USA, your perfect development partner is ready to push boundaries with you.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fourth section*/}

      <section className="bd-about-area pb-80">
        <div className="bd-custom-container">
          <div className="bd-about-four-bg pb-0 fix">
            <div className="bd-about-shape-box">
              <div className="container" style={{ maxWidth: "1270px" }}>
                <div className="row justify-content-center">
                  <div className="col-xl-6 col-lg-8 fourth_responsive_section1">
                    <div className="bd-about-text bd-about-text-four z-index">
                      <div className="bd-section-title-wrapper">
                        <h2 className="bd-section-title mb-15  md-pr-50 dedicate-last-tittle">
                        Built With Heart, Backed By People Who Truly Care
                        </h2>
                        <p className="">
                        Behind every business goal is a human story: late nights, tough decisions, and a dream you refuse to give up on. That’s exactly why our dedicated resources aren't just here to work—they’re here to believe in your journey. We bring in people who care deeply, who show up with passion, and who treat your goals like their own. This isn’t just support, it’s partnership rooted in purpose. When you’re ready to build something real, we’re ready to stand with you every step of the way.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-8 pl-30 fourth_responsive_section2">
                    <div className="bd-about-img">
                      <img
                        src={'https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1747195827/USA%20website/HIRE%20A%20RESOURCE/Hire_A_Dedicated_Resources_1_qtlzk6.jpg'}
                        className="xss-w-full rounded-10"
                        alt="about img not found"
                      />
                      {/* <img className="bd-about-shape bd-about-shape-6 hero-1-dot" src={shape6} alt="shape img not found"/> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Banner Section */}
      <section
        className="bd-video-area pt-135 pb-130"
        style={{ backgroundColor: "#5c0385" }}
      >
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row responsive-banner">
            <div className="col-lg-12 first_section">
              <div className="bd-video-text">
                <h2 className="bd-video-title first-para-resp">
                Looking to Hire a Dedicated Developer in USA?
                </h2>
                <p className="contact_section second-para-resp">
                You're here at the right moment.
                </p>
                <p className="contact_subtext">
                Outstanding Developers, Let's Kickstart the Project!
                </p>
              </div>
            </div>
            <div className="col-lg-12 second_section">
              <div className="contact-stuff pt-30">
                <div className="contact_icon icon_respon pt-15 pl-50">
                  <FontAwesomeIcon
                    icon={faPhone}
                    style={{ fontSize: "30px" }}
                  />
                </div>
                <div className="contact_txt ">
                  <p className="contact-sub-text">CALL US NOW</p>
                  <a
                    href="tel:+1 (647) 446-9073"
                    style={{ fontSize: "17px" }}
                    className="mbb-5 pb-20"
                  >
                    +1 (647) 446-9073
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CanadaFooter />
    </div>
  );
};

export default CanadaDedicatedResource;
